import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { FREE_TRIAL_PLAN_ID } from "../../config/service";
import { getDaysFromCurrentDate } from "../../utils/convert-date";
import {
  PRODUCT_ID_DNC,
  PRODUCT_ID_WMA,
  PRODUCT_ID_WMC,
  PRODUCT_ID_WMS,
} from "../../utils/subscription-plan";
import { getStorage, setStorage } from "../helpers/storage";
import { parentOrgId } from "../mockData/multitenancy";
import { getAllAccounts } from "./accounts";

export const userdata = async () => {
  let localAccounts = await getStorage("ACCOUNTS");
  if (!localAccounts) {
    localAccounts = getAllAccounts();
  }
  await setStorage("ACCOUNTS", localAccounts);
  const localOrgs = await getStorage("ORGANIZATIONS");
  const accounts = [];
  const departments = [];
  const orgs = [];
  localOrgs &&
    localOrgs.length > 0 &&
    localOrgs.forEach((org, index) => {
      if (index === 0) {
        org["isSelected"] = true;
      }

      orgs.push(org);
    });
  localOrgs &&
    localOrgs.length > 0 &&
    localOrgs[0].Departments.forEach((dept) => {
      dept["isSelected"] = true;
      departments.push(dept);
    });
  localAccounts.forEach((acc) => {
    let account = {
      isSelected: false,
      accountName: acc.AccountName,
      accountNumber: acc.AccountNumber,
    };
    accounts.push(account);
  });
  return {
    Organizations: orgs,
    Departments: departments,
    Regions: [
      {
        isSelected: true,
        regionNumber: "us-east-1",
        regionName: "US East (N. Virginia)",
      },
      {
        isSelected: true,
        regionNumber: "us-east-2",
        regionName: "US East (Ohio)",
      },
      {
        isSelected: true,
        regionNumber: "us-west-1",
        regionName: "US West (N. California)",
      },
      {
        isSelected: true,
        regionNumber: "us-west-2",
        regionName: "US West (Oregon)",
      },
      {
        isSelected: true,
        regionNumber: "ap-south-1",
        regionName: "Asia Pacific (Mumbai)",
      },
      {
        isSelected: true,
        regionNumber: "ap-northeast-2",
        regionName: "Asia Pacific (Seoul)",
      },
      {
        isSelected: true,
        regionNumber: "ap-southeast-1",
        regionName: "Asia Pacific (Singapore)",
      },
      {
        isSelected: true,
        regionNumber: "ap-southeast-2",
        regionName: "Asia Pacific (Sydney)",
      },
      {
        isSelected: true,
        regionNumber: "ap-northeast-1",
        regionName: "Asia Pacific (Tokyo)",
      },
      {
        isSelected: true,
        regionNumber: "ca-central-1",
        regionName: "Canada (Central)",
      },
      {
        isSelected: true,
        regionNumber: "eu-central-1",
        regionName: "EU (Frankfurt)",
      },
      {
        isSelected: true,
        regionNumber: "eu-west-1",
        regionName: "EU (Ireland)",
      },
      {
        isSelected: true,
        regionNumber: "eu-west-2",
        regionName: "EU (London)",
      },
      {
        isSelected: true,
        regionNumber: "eu-west-3",
        regionName: "EU (Paris)",
      },
      {
        isSelected: true,
        regionNumber: "sa-east-1",
        regionName: "South America (Su00e3o Paulo)",
      },
    ],
    Accounts: accounts,
  };
};

export const userDetails = {
  CustomerType: FREE_TRIAL_PLAN_ID,
  UserId: uuidv4(),
  OrganizationId: parentOrgId,
  Email: localStorage.getItem("email"),
  Name: localStorage.getItem("username"),
  IsLegacy: false,
  Features: {
    MTEnabled: true,
    FBPEnabled: true,
    MAPEnabled: true,
    TerraformEnabled: true,
  },
  MFAEnabled: false,
  MFAEnforcement: "",
  MFAConfigured: false,
  SubscriptionMetadata: {
    SubscriptionEndAt: getDaysFromCurrentDate(14),
    SubscriptionId: uuidv4(),
    IsTrial: false,
    ProductIds: [
      PRODUCT_ID_DNC,
      PRODUCT_ID_WMA,
      PRODUCT_ID_WMS,
      PRODUCT_ID_WMC,
    ],
    Status: "Active",
    TrialExpired: false,
    TrialEndDate: moment().add(14, "days"),
  },
  CompanyName: "MontyCloud",
  Token:
    "eyJraWQiOiJCN2NqMDRNbWkyK01OdklsUjZuRit0b2srbTc5c0pwR2h3RUNCdHBsaHFRPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI1OTZmZGNhMC04Y2NlLTQxYjEtYTYzNS1hZmFhMTA0ZTdhN2IiLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy1lYXN0LTEuYW1hem9uYXdzLmNvbVwvdXMtZWFzdC0xX2Z4WFRJS1psciIsImNvZ25pdG86dXNlcm5hbWUiOiI1OTZmZGNhMC04Y2NlLTQxYjEtYTYzNS1hZmFhMTA0ZTdhN2IiLCJhdWQiOiJoNXJwbGsxaXRjbzU0bGJwdjFnNWR0aW9hIiwiY3VzdG9tOkNvbXBhbnlOYW1lIjoiVmFyc2hhIiwiZXZlbnRfaWQiOiJhNmUwNWUyMi03MjUxLTExZTktOGQ4My1jMTFlOTA4YTA2ZDgiLCJ0b2tlbl91c2UiOiJpZCIsImF1dGhfdGltZSI6MTU1NzQwMzA2MywibmFtZSI6IlZhcnNoYSIsImV4cCI6MTU1NzQ3ODYwNiwiaWF0IjoxNTU3NDc1MDA2LCJlbWFpbCI6InZhcnNoYUBtb250eWNsb3VkLmNvbSJ9.3A-kghcWRwSR-iPFZKuEfZAA3UM-dHPBPMP0w4nIyAeFs74uxKxuU6EpNZcLsZbhAr3pTW8VxI-n4RdrzZgdgEUsV0SGyUZf6lsjKFoqflmKvI7L8nmSXUpsNV2C55qWBbQMlnJ8xtD83RydiNFyCsoYrnbs5R71GTea7vaQVS-fk3s4dPiApxZBFUpkr-Iz9_fuPuVXasODTgbuKzNkPO53-PpJQLqWefaShu4_OnmbCpUSUIqxfeZeFhppLYtiF8Sy5PgpaRM8kJ0Xod1DYd4QrIB5hJT_-RYM2t-_EstuqWLhfrDV_FqmSnTPnApEQKez_tTKmV6H-cA3ia85nw",
  AccessToken:
    "eyJraWQiOiJxZWtsZzM0bkw2ZmJ1Q3FYcE5aZG9YOVhMajJuN2NTUFJOUWYrM0pYSDVVPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI1OTZmZGNhMC04Y2NlLTQxYjEtYTYzNS1hZmFhMTA0ZTdhN2IiLCJldmVudF9pZCI6ImE2ZTA1ZTIyLTcyNTEtMTFlOS04ZDgzLWMxMWU5MDhhMDZkOCIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE1NTc0MDMwNjMsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy1lYXN0LTEuYW1hem9uYXdzLmNvbVwvdXMtZWFzdC0xX2Z4WFRJS1psciIsImV4cCI6MTU1NzQ3ODYwNiwiaWF0IjoxNTU3NDc1MDA2LCJqdGkiOiIxZmUzMzc3Yi0xMTUwLTRhZDgtYTdhNy1jNDkxZWNjNTgwYzYiLCJjbGllbnRfaWQiOiJoNXJwbGsxaXRjbzU0bGJwdjFnNWR0aW9hIiwidXNlcm5hbWUiOiI1OTZmZGNhMC04Y2NlLTQxYjEtYTYzNS1hZmFhMTA0ZTdhN2IifQ.D97Al_dpsmoRQSA_KjuDvizEK7R26RXaROZw9sYI7gLYmvpCjGhSYTHOwDSRQHIJhnqgzd2YRS-uP0SlYbvhkENpVUC4XCfIyYPO4Yz9ysNaK6-FUEjPa_l1qY1DB8zL2STahD6GbAKn7z6pR44314lZ06DTG1tqIbr9q33kKchDf7-zKxNGSlSWk5zzq7G29wxE7m61Si76QNQUoxGvn7zLR99EpXQWx-Q5_TRtofbYnfjaVWyJs5n3aOdzUcaDrMbDqW7ir6Y4-1RuEyiyHFrr3sQAdWo95F0_lWQBbmOczCJOSkeBRd0PxDlQUR_moGoOiSfLKuO-XqD63UeRZg",
};
